<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import columns from '@/pages/settings/smsBlockTab/columns';
import {
  TYPE_LIST,
  CATEGORY_LIST,
  CREATE_NEW,
  CLOSE,
  SAVE,
  SMS_TITLE,
  SMS_TEXT,
  VARIABLE_LIST,
  LINK_LIST,
  SMS_TYPE,
  SMS_CATEGORY,
} from './constants';

const b = bem('sms-tab');
export default {
  components: {
  },
  data() {
    return {
      isShowEditor: false,
      smsEditData: {},
      title: '',
      body: '',
      type: TYPE_LIST[0],
      editIsDefault: false,
      category: CATEGORY_LIST[0],
      // typeFilter: TYPE_LIST[0],
      // categoryFilter: CATEGORY_LIST[0],
      isEditState: true,
      textPopup: null,
      popupSelectorValue: { value: '', label: '' },
      isFilterChanged: false,
      columns: columns(
        CATEGORY_LIST.filter((item, index) => index !== 0),
        TYPE_LIST.filter((item, index) => index !== 0),
      ),

      CREATE_NEW,
      CATEGORY_LIST,
      TYPE_LIST,
      CLOSE,
      SAVE,
      SMS_TITLE,
      SMS_TEXT,
      VARIABLE_LIST,
      LINK_LIST,
      SMS_TYPE,
      SMS_CATEGORY,
    };
  },
  methods: {
    ...mapActions({
      getSmsTemplatesAction: 'templates/getSmsTemplates',
      addOrChangeSmsTemplateAction: 'templates/addOrChangeSmsTemplate',
      deleteSmsTemplateAction: 'templates/deleteSmsTemplate',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    getRequestBody() {
      const requestBody = {
        limit: 999999,
        offset: 0,
      };
      // if (this.categoryFilter.value) {
      //   const categoryField = 'filter[category]';
      //   requestBody[categoryField] = this.categoryFilter.value;
      // }
      // if (this.typeFilter.value) {
      //   const typeField = 'filter[type]';
      //   requestBody[typeField] = this.typeFilter.value;
      // }
      return requestBody;
    },
    onEdit(item) {
      if (Object.keys(item).length) {
        this.smsEditData = item;
        this.title = item.title;
        this.body = item.body;
        this.editIsDefault = item.isDefault;
        this.type = item.type
          ? TYPE_LIST.find((itm) => itm.value === item.type)
          : TYPE_LIST[0];
        this.category = item.category
          ? CATEGORY_LIST.find((itm) => itm.value === item.category)
          : CATEGORY_LIST[0];
        this.isEditState = item.isEdit;
        this.isShowEditor = true;
      } else {
        const [firstType] = TYPE_LIST;
        const [firstCategory] = CATEGORY_LIST;
        this.isShowEditor = false;
        this.title = '';
        this.body = '';
        this.editIsDefault = false;
        this.type = firstType;
        this.category = firstCategory;
        this.isEditState = true;
        this.smsEditData = {};
      }
    },
    onClickSave() {
      this.addOrChangeSmsTemplateAction(
        {
          data: {
            title: this.title,
            body: this.body,
            type: this.type.value,
            category: this.category.value,
            isDefault: this.editIsDefault,
            isEdit: this.isEditState,
          },
          isNew: !this.smsEditData.id,
          id: this.smsEditData.id,
          params: this.getRequestBody(),
        },
      );
      if (this.smsEditData.id) {
        this.onEdit({});
      }
    },
    onDelete(id) {
      this.deleteSmsTemplateAction({
        id,
        params: this.getRequestBody(),
      });
    },
    onChangeText(e) {
      const {
        target: {
          value,
        },
      } = e;
      if (value.length >= 2) {
        const subString = value.substr(value.length - 2);
        if (subString === '[[') {
          e.target.blur();
          this.textPopup = 'link';
        }
        if (subString === '{{') {
          e.target.blur();
          this.textPopup = 'variable';
        }
      }
      this.body = value;
    },
    closeVariable() {
      this.textPopup = null;
      this.popupSelectorValue = { value: '', label: '' };
      this.body = this.body.slice(0, -2);
    },
    saveVariable() {
      if (this.textPopup === 'variable') {
        if (this.popupSelectorValue.value === 'orderMessageLink') {
          this.body = `${this.body.slice(0, -2)}[[${this.popupSelectorValue.value}]]`;
        } else {
          this.body = `${this.body}${this.popupSelectorValue.value}}}`;
        }
        this.textPopup = null;
        this.popupSelectorValue = { value: '', label: '' };
      } else if (this.textPopup === 'link') {
        this.body = `${this.body}|${this.popupSelectorValue.value}]]`;
        this.textPopup = null;
        this.popupSelectorValue = { value: '', label: '' };
      }
    },
    getItemLabel(record, list, key) {
      const item = list.find((itm) => itm.value === record[key]);
      return (item || {}).label;
    },
    updateToggle(name, value) {
      this[name] = value;
    },
    setTypeValue(value) {
      this.type = TYPE_LIST.find((itm) => itm.value === value);
    },
    setCategoryValue(value) {
      this.category = CATEGORY_LIST.find((itm) => itm.value === value);
    },
    setPopupSelectorValue(list, value) {
      this.popupSelectorValue = list.find((item) => item.value === value);
    },
    setShowEditor(value) {
      this.isShowEditor = value;
    },
  },
  mounted() {
    this.getSmsTemplatesAction(this.getRequestBody());
  },
  computed: {
    ...mapState({
      smsTemplates: (state) => state.templates.smsTemplates,
      isLoading: (state) => state.templates.isLoading,
    }),
  },
  watch: {
    isFilterChanged() {
      this.getSmsTemplatesAction(this.getRequestBody());
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div v-if="!isShowEditor" :class="b('sms-top-block')">
      <a-button
        type="primary"
        @click="() => { setShowEditor(true) }"
      >
        {{CREATE_NEW}}
      </a-button>
    </div>
    <a-table
      :class="b('table', { hide: isShowEditor })"
      :columns="columns"
      :dataSource="smsTemplates.data"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'category'">
          {{getItemLabel(record, CATEGORY_LIST, 'category')}}
        </template>
        <template v-if="column.dataIndex === 'type'">
          {{getItemLabel(record, TYPE_LIST, 'type')}}
        </template>
        <template v-if="column.dataIndex === 'actions'">
          <div :class="b('action-buttons')">
            <a-button
              type="primary"
              html-type="button"
              @click="() => {onEdit(record)}"
            >
              Edit
            </a-button>
            <a-button
              type="primary"
              html-type="button"
              danger
              @click="() => {onDelete(record.id)}"
            >
              Delete
            </a-button>
          </div>
        </template>
      </template>
    </a-table>
    <div v-if="isShowEditor" :class="b('sms-editor')">
      <div :class="b('sms-top-block')">
        <div :class="b('name-block')">
          <div :class="b('name')">Default</div>
          <a-switch
            :checked="editIsDefault"
            checked-children="Yes"
            un-checked-children="No"
            @click="updateToggle('editIsDefault', !editIsDefault)"
          />
        </div>
        <div :class="b('name-block')">
          <div :class="b('name')">Edit</div>
          <a-switch
            :checked="isEditState"
            checked-children="Yes"
            un-checked-children="No"
            @click="updateToggle('isEditState', !isEditState)"
          />
        </div>
        <a-button
          type="primary"
          html-type="button"
          @click="onClickSave()"
          :disabled="!category.value || !type.value || !body || !title"
        >
          {{SAVE}}
        </a-button>
        <a-button
          html-type="button"
          @click="onEdit({})"
        >
          {{CLOSE}}
        </a-button>
      </div>
      <div :class="b('actions')">
        <div :class="b('left-block')">
          <div :class="b('row')">
            <div :class="b('title')">{{SMS_TITLE}}</div>
            <a-input
              type="text"
              v-model:value="title"
            />
          </div>
          <div :class="b('row')">
            <div :class="b('title')">{{SMS_TEXT}}</div>
            <a-textarea
              :value="body"
              :auto-size="{ minRows: 5, maxRows: 5 }"
              @change="onChangeText"
            />
          </div>
        </div>
        <div :class="b('right-block')">
          <div :class="b('row')">
            <div :class="b('title')">{{SMS_TYPE}}</div>
            <a-select
              style="width: 180px"
              :value="type"
              :options="TYPE_LIST"
              @change="setTypeValue"
            />
          </div>
          <div :class="b('row')">
            <div :class="b('title')">{{SMS_CATEGORY}}</div>
            <a-select
              style="width: 180px"
              :value="category"
              :options="CATEGORY_LIST"
              @change="setCategoryValue"
            />
          </div>
        </div>
      </div>
      <div v-if="textPopup" :class="b('add-variable')">
        <div :class="b('add-variable-block')">
          <div :class="b('style-item')">
            <div :class="b('title')">{{textPopup==='variable' ? 'Variable' : 'Link'}}</div>
            <a-select
              style="width: 180px"
              :value="popupSelectorValue"
              :options="textPopup==='variable' ? VARIABLE_LIST : LINK_LIST"
              @change="(e) => {
                setPopupSelectorValue(textPopup==='variable' ? VARIABLE_LIST : LINK_LIST, e);
              }"
            />
          </div>
          <div :class="b('add-variable-buttons')">
            <a-button
              html-type="button"
              @click="closeVariable"
            >
              Close
            </a-button>
            <a-button
              type="primary"
              html-type="button"
              @click="saveVariable"
              :disabled="!popupSelectorValue.value"
            >
              Save
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
